import { type HotelRoomOfferApi } from '@revolugo/booking-api-client'

import type {
  GraphQlComputedHotelRoom,
  GraphQlHotelRoomOffer,
} from '@revolugo/graphql/private'

export interface HotelRoomExtended
  extends Pick<GraphQlComputedHotelRoom, 'description' | 'bedsPretty'> {
  count: number
}

export interface HotelRoomOfferAdapterProps
  extends Pick<
    GraphQlHotelRoomOffer,
    'price' | 'taxIncludedPrice' | 'breakfastCount'
  > {
  hotelRooms: HotelRoomExtended[]
}

export class HotelRoomOfferAdapter {
  hotelRoomOfferApi: HotelRoomOfferApi

  constructor(hotelRoomOfferApi: HotelRoomOfferApi) {
    this.hotelRoomOfferApi = hotelRoomOfferApi
  }

  toHotelRoomOffer(): HotelRoomOfferAdapterProps {
    return {
      ...this.hotelRoomOfferApi,
      breakfastCount: this.hotelRoomOfferApi
        .breakfastCount as GraphQlHotelRoomOffer['breakfastCount'],
      hotelRooms: this.hotelRoomOfferApi.hotelRooms!.map(hotelRoom => ({
        bedsPretty: hotelRoom.bedsPretty,
        count: hotelRoom.count,
        description: hotelRoom.description,
      })) as HotelRoomExtended[],
      price: this.hotelRoomOfferApi.price!,
      taxIncludedPrice: this.hotelRoomOfferApi.taxIncludedPrice!,
    }
  }
}
